import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Container, Form, Button, Message, Tab, Segment } from 'semantic-ui-react'
import queryString from 'query-string';
import Password from "../../Password";
import configLoader from "../../../helpers/configLoader";

export default class ResetPasswordValidate extends Component {
    constructor(props){
        super(props);
        let query = queryString.parse(this.props.location.search);
        this.state = {
            key: (query.key ? query.key : ''),
            user: (query.login ? query.login : ''),
            newPassword: "",
            loading: false,
            error: null,
            message: null,
        };
    }

    componentDidMount() {
        if (this.state.key === '' || this.state.user === '') {
            return
        }
        this.setState({ loading: true });
        fetch( configLoader.ApiVerifyReset, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                key: this.state.key,
                user: this.state.user,
            })
        }).then(response => response.json()
        ).then((data) => {
            if (data.code === 200) {
                this.setState({ loading: false })
            } else {
                this.setState({
                    loading: false,
                    error: data.message
                })
            }
        })
    }

    doReset() {
        this.setState({ loading: true });
        fetch( configLoader.ApiReset, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                key: this.state.key,
                user: this.state.user,
                password: this.state.newPassword,
            })
        }).then(response => response.json()
        ).then((data) => {
            if (data.code === 200) {
                this.setState({
                    loading: false,
                    message: "You're password has been reset successfully"
                })

            } else {
                this.setState({
                    loading: false,
                    error: data.message
                })
            }
        })
    }

    render() {
        let messages = null;
        let content = null;
        if (this.state.message) {
            messages = <Message
                positive
                icon='check'
                content={ this.state.message }
            />;
            content = <Segment basic size='small' textAlign='center'>
                You can login <Link to={'/user'}>here</Link>.
            </Segment>
        } else if (this.state.error) {
            messages = <Message
                negative
                icon='warning'
                content={ this.state.error }
            />;
            content = <Segment basic size='small' textAlign='center'>
                You can resend the email <Link to={'/user/lost-password'}>here</Link>.
            </Segment>
        } else if (this.state.key === '' || this.state.user === '') {
            messages = <Message
                negative
                icon='warning'
                content={ 'Please follow the link sent to your email' }
            />;
            content = <Segment basic size='small' textAlign='center'>
                You can resend the email <Link to={'/user/lost-password'}>here</Link>.
            </Segment>
        } else {
            content = <Form loading={this.state.loading}>
                    <Form.Input style={{display: 'none'}} />
                    <Form.Input style={{display: 'none'}} type='password'/>
                <p>Please enter your new password:</p>
                    <Password
                        onChange={(e) => {
                            this.setState({'newPassword': e.target.value})
                        }}
                        fluid
                        value={this.state.newPassword}
                        placeholder='Password'
                        type='password'
                    />
                    <Button fluid size='large' primary onClick={ () => this.doReset() }>
                        Reset password
                    </Button>
                </Form>
        }
        return (
            <Container text id='content'>
                <div class="loginFormWrapper">
                    <Tab panes={[
                        { menuItem: 'Reset your password', render: () => (
                                <Tab.Pane>
                                    { messages }
                                    { content }
                                </Tab.Pane>
                            ) }]}
                    />
                </div>
            </Container>
        )
    }
}